<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <form class="form w-100" id="kt_field_form" @submit.prevent="handleInvitationSubmit">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('nps.send_invitation')  }}</h5>
            <div class="btn btn-type btn-sm btn-active-light-primary ms-2" @click="closeModal">
                <span class="svg-type svg-type-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <Select2
                      :parent-id="'#'+id"
                      :is-required="false"
                      :multiple="true"
                      :show-search="true"
                      :name="'contacts'+id"
                      :label="$t('nps.form.contacts')"
                      v-model="formData.contacts"
                  >
                    <option v-for="contact in contacts" :value="contact?.id" :key="contact?.id">
                      {{ contact.lastname }} {{ contact.firstname }}
                    </option>
                  </Select2>
              </div>
              <div class="col-12">
                <TagInput id="id" type="email" name="emails" :required="false" v-model="formData.emails" help="nps.form.emails" label="nps.form.emails"/>
              </div>
              <div class="col-12">
                <CKEditor
                    labelClass="form-label fs-6 text-black"
                    :label="$t('nps.form.mail')"
                    id="nps-mail-editor"
                    :content="filterMessage"
                    @text="getMail"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :loading="loading"></Button>
          </div>
        </div>
      </div>
    </form>
  </div>

</template>

<script setup>
/* eslint-disable */
import {computed, ref, defineProps, onMounted, watch, nextTick} from "vue";
import {useStore} from "vuex";
import Button from "@/components/Button.vue";
import Select2 from "@/components/Select2.vue";
import CKEditor from "@/components/CKEditor.vue";
import TagInput from "@/components/Form/TagInput.vue";
import { useRoute } from "vue-router";

const TYPE = "NPS"
const store = useStore()
const route = useRoute()

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
})

const emits = defineEmits(['load'])
const loading = ref(false)
const formData = ref({
  contacts: [],
  emails: [],
  content: ""
})

const contacts = computed(() => store.getters['contacts/getContacts'])
const mailMessage = computed(() => store.getters['mail/getMailMessage'])
const filterMessage = computed(() => mailMessage.value.filter((message) => message.type.value == TYPE)[0]?.content)

function closeModal(){
  $('#'+props.id).modal('toggle')
}


function handleInvitationSubmit(){
  loading.value = true
  const data = {
    ...formData.value,
    content: formData.value.content == "" ? filterMessage.value : formData.value.content, 
    nps_id: route.params.id
  }
  store.dispatch('nps/sendNpsInvitation', data)
      .then(res => {
        window.toastr['success'](i18n.global.t("notification.nps_invitation_sended"))
        closeModal()
        formData.value = {
          contacts: [],
          emails: [],
          content: ""
        }
      })
      .catch((err) => {
      })
      .finally(() => loading.value = false)
}

function getMail(text) {
  formData.value.content = text
}

onMounted(() => {
})
</script>

<style scoped>
.role {
  border: 1px solid #fff;
  box-shadow: 0 .1rem 1rem .25rem rgba(0, 0, 0, .05);
}
</style>